<script setup lang="ts">
import type { ContentScope, ContentScopeSubject } from '@/types/contentScope'

const props = withDefaults(
  defineProps<{
    subject: ContentScopeSubject
    scope?: ContentScope | null
    confirmLabel?: string
    isProcessing?: boolean
  }>(),
  {
    scope: null,
    confirmLabel: '',
    isProcessing: false
  }
)

const emit = defineEmits<{
  confirm: [scope: ContentScope]
  cancel: []
}>()

const open = defineModel<boolean>('open', { required: true })

const { t } = useI18n()

const selected = ref<ContentScope | null>(null)
const hasTriedToConfirm = ref(false)
const hasError = computed(() => hasTriedToConfirm.value && !selected.value)

watch(
  open,
  (isOpen) => {
    if (!isOpen) return
    selected.value = props.scope
    hasTriedToConfirm.value = false
  },
  { immediate: true }
)

const confirm = () => {
  if (!selected.value) {
    hasTriedToConfirm.value = true
    return
  }
  emit('confirm', selected.value)
}
</script>

<template>
  <BaseModal
    :is-open="open"
    size="xl"
    :heading-title="t(`contentScope.subjects.${subject}.fieldTitle`)"
    :cancel="t('global.words.cancel')"
    :link-text="confirmLabel || t('global.words.continue')"
    :is-processing="isProcessing"
    @close="emit('cancel')"
    @click="confirm"
  >
    <ContentScopeQuestion v-model="selected" :subject :error="hasError" :with-label="false" />
  </BaseModal>
</template>
